import React, { useEffect } from "react"
import Presentation from "./Presentation"
import { connect } from "react-redux"
import { removeMember, updatePermissions } from "../../../middleware"

function Container(props) {
  const [state, setState] = React.useState({
    assignees: props.assignees,
    initialAssignee: [],
  })

  useEffect(() => {
    setState({
      assignees: props.assignees,
    })
  }, [props.assignees])

  const handleUpdateLevels = (uid) => {
    const {   updatePermissions   } = props
    let level = state.assignees.filter((assignee) => uid === assignee.uid )[0]
    
    let data = {
      create: level.create,
      update: level.update,
      read: level.read,
      del: level.delete,
      projectId: props.projectId,
      uid:   uid
    }
    updatePermissions(data)
    // dispatch({
    //     type : UPDATE_ACCESS_LEVELS,
    //     payload : {
    //         data : {
    //             uid : uid,
    //             newAccessLevel : {
    //                 create : level.create,
    //                 update : level.update,
    //                 read : level.read,
    //                 delete : level.delete,
    //                 projectId : state.project.id
    //             }
    //         }
    //     }
    // })
  }
  const handleRemove = (uid) => {
    const { removeMember } = props
    let data = {
      employees: [uid],
      projectId: props.projectId,
    }
    removeMember(data)
    // dispatch({
    //     type : REMOVE_MEMBER,
    //     payload : {
    //         data : {
    //             projectId : state.project.id,
    //             employeeUID : uid
    //         },
    //         dispatch : dispatch
    //     }
    // })
  }

  const handleLevelChange = (uid, permission, key) => {
    let currState = JSON.parse(JSON.stringify(state))
    let accessLevels = currState.assignees
    accessLevels.forEach((access, index) => {
      if (access.uid === uid) {
        accessLevels[index][key] = !permission
      }
    })
    setState({
      ...state,
      assignees: accessLevels,
    })
  }
  return (
    <div>
      {
        <Presentation
          assignees={state.assignees}
          handleLevelChange={handleLevelChange}
          handleUpdateLevels={handleUpdateLevels}
          handleRemove={handleRemove}
        />
      }
    </div>
  )
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    removeMember: (payload) => {
      dispatch(removeMember(payload))
    },
    updatePermissions: (payload) => {
      dispatch(updatePermissions(payload))
    },
  }
}

export default connect(null, mapDispatchToProps)(Container)
